import React, { Component } from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import { TextField, SelectField } from "redux-form-material-ui";
import { Card, CardText, CardTitle } from "material-ui/Card";
import { connect } from "react-redux";
import download from "downloadjs";
import { Link } from "react-router-dom";
import { RaisedButton, FlatButton, FloatingActionButton } from "material-ui";
import SearchIcon from "material-ui/svg-icons/action/search";
import {
	actionDownloadFile,
	actionGenerateTicketOnDemand,
	actionRegenerateTicketOnDemand,
	actionUpdateBoleta
} from "../../actions/BoletaActions";
import { actionGetEmpresaByCuit } from "../../actions/EmpresaActions";
import { BOLETAS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import { MODE_CRU_CREATE, MODE_CRU_SHOW } from "../../actions/ActionConstants";
import InputMask from "../../components/InputMask/InputMask";
import {
	onKeyPressNumberAndCommaOnly,
	required
} from "../../common/validaciones";
import AddPayment from "../../components/AddPayment/AddPayment";
import AppMem from "../../common/AppMem";
import { actionGetPaymentMethodList } from "../../actions/PaymentMethodActions";

class TicketOnDemandForm extends Component {
	constructor(props) {
		super(props);
		this.state = { isTicketGenerated: false };
	}

	componentWillMount() {
		if (!this.props.modeCRU) this.props.history.push(BOLETAS);
		else if (this.props.modeCRU !== MODE_CRU_CREATE) {
			this.props.actionGetPaymentMethodList();
			this.props.initialize({
				...this.props.boleta,
				monthPeriod: parseInt(this.props.boleta.monthPeriod, 10),
				yearPeriod: parseInt(this.props.boleta.yearPeriod, 10)
			});
		}
	}

	onSubmit(formValues) {
		let values = Object.assign({}, formValues);
		values.ticketHeader.ticketDetail[0] = Object.assign(
			{},
			formValues.ticketHeader.ticketDetail[0]
		);
		values.ticketHeader.ticketDetail[0].amount = Number(
			("" + values.ticketHeader.ticketDetail[0].amount).replace(/,/, ".")
		);
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			values.idCompany = this.props.company.id;
			this.props.actionGenerateTicketOnDemand(values, this.returnOnSubmit);
		} else
			this.props.actionRegenerateTicketOnDemand(
				this.props.boleta.idPayment,
				this.props.boleta.ticketHeader.id,
				values,
				this.returnOnSubmit
			);
	}
	onSubmitPartialPayment(formValues) {
		let values = Object.assign({}, formValues);
		values.ticketHeader.ticketDetail[0] = Object.assign(
			{},
			formValues.ticketHeader.ticketDetail[0]
		);
		values.ticketHeader.ticketDetail[0].amount = Number(
			("" + values.ticketHeader.ticketDetail[0].amount).replace(/,/, ".")
		);
		let dateNow = new Date();
		dateNow = Util.formatDateToISODate(dateNow);
		let Date01 = false;
		if (dateNow <= values.ticketHeader.expiredDate01) {
			Date01 = true;
		}
		let paidTotal = 0;
		let paidTotalFlag = false;
		values.ticketHeader.listPartialPayment.forEach((partialPayment, i) => {
			paidTotal = parseFloat(paidTotal) + parseFloat(partialPayment.paidAmount);
			if (partialPayment.totalPayment) {
				paidTotalFlag = true;
			}
		});
		if (Date01 && !paidTotalFlag) {
			if (paidTotal >= values.ticketHeader.feeAmount01) {
				AppMem.confirmDialog.open({
					title: "Registrar Los Pagos",
					messageConfirm:
						"¿Esta seguro que desea registrar los pagos aunque los pagos totales igualan o superan el 1º Vencimiento, sin registrarlo como pago total?",
					onAccept: this.onTapConfirmPaid.bind(values.ticketHeader)
				});
			}
		} else if (paidTotal >= values.ticketHeader.feeAmount02 && !paidTotalFlag) {
			AppMem.confirmDialog.open({
				title: "Registrar Los Pagos",
				messageConfirm:
					"¿Esta seguro que desea registrar los pagos aunque los pagos totales igualan o superan el 2º Vencimiento, sin registrarlo como pago total?",
				onAccept: this.onTapConfirmPaid(values.ticketHeader)
			});
		} else {
			this.onTapConfirmPaid(values.ticketHeader);
		}
	}
	onTapConfirmPaid(valuesFinal) {
		this.props.actionUpdateBoleta(valuesFinal, this.onReturnUpdate.bind(this));
	}
	onReturnUpdate(flag) {
		if (flag) {
			Util.showNoty(SUCCESS, "Se registraron los pagos correctamente");
			this.props.history.push(BOLETAS);
		} else {
			Util.showNoty(ERROR, "Error al registrar los pagos");
		}
	}

	returnOnSubmit = response => {
		this.downloadFile(response.nombreArchivo);
	};

	downloadFile(fileName) {
		this.props.actionDownloadFile(fileName, this.returnDownload.bind(this));
	}

	returnDownload(blob) {
		const companyName = this.props.company
			? this.props.company.name
			: this.props.boleta.nameCompany;
		let nombreArchivo =
			this.props.formValues.yearPeriod +
			"-" +
			this.props.formValues.monthPeriod +
			"-" +
			companyName +
			"-UPSRA.pdf";
		download(blob, nombreArchivo);
		this.setState({ isTicketGenerated: true });
	}

	onClickSearch = () => {
		this.props.actionGetEmpresaByCuit(this.props.formValues.cuitCompany);
	};

	render() {
		let meses = UtilPC.menuItemsMonths();
		return (
			<div className="center">
				<Card className="card">
					<CardTitle title="Generar boleta a demanda" />
					<CardText>
						<form>
							<div className="content-papercard">
								<div>
									<TextField
										style={{ minWidth: "50%" }}
										floatingLabelText="Empresa"
										value={
											this.props.company
												? this.props.company.name
												: this.props.boleta ? this.props.boleta.nameCompany : ""
										}
										disabled
									/>
								</div>
								<div className="columns-row-between" style={{ width: "20%" }}>
									<Field
										name="cuitCompany"
										style={{ marginRight: "6%" }}
										component={InputMask}
										floatingLabelText="CUIT"
										parse={Util.formatCuitToNumber}
										mask={[
											/\d/,
											/\d/,
											"-",
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											"-",
											/\d/
										]}
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									/>
									<FloatingActionButton
										style={{ marginTop: "12%" }}
										onClick={this.onClickSearch}
										zDepth={0}
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									>
										<SearchIcon />
									</FloatingActionButton>
								</div>
								<div className="columns-row-between" style={{ width: "75%" }}>
									<Field
										style={{ width: "25%" }}
										name="monthPeriod"
										component={SelectField}
										floatingLabelText="Mes"
										disabled={!this.props.company}
										validate={required}
									>
										{meses}
									</Field>
									<Field
										style={{ width: "25%" }}
										name="yearPeriod"
										component={SelectField}
										floatingLabelText="Año"
										disabled={!this.props.company}
										validate={required}
									>
										{UtilPC.menuItemsYears()}
									</Field>
									<Field
										name="ticketHeader.ticketDetail[0].freeConcept"
										component={TextField}
										floatingLabelText="Concepto"
										multiLine
										rowsMax={4}
										disabled={!this.props.company}
										validate={required}
									/>
								</div>
								<VerticalListFields
									titleText="Vencimientos"
									titleClass="title-papercard-primary"
									paperClass="papercard top20 bottom20"
									contentClass="content-papercard-row-center padding20"
								>
									<div className="rows-column-simple bottom25">
										<div className="columns-row-between">
											<Field
												name="ticketHeader.ticketDetail[0].amount"
												component={TextField}
												floatingLabelText="Total Pagar"
												format={Util.formatPesos}
												parse={Util.parsePesos}
												disabled={!this.props.company}
												onKeyPress={onKeyPressNumberAndCommaOnly}
												validate={required}
											/>
											<Field
												name="ticketHeader.expiredDate01"
												component={TextField}
												floatingLabelText="1er Vencimiento"
												disabled
												format={Util.formatDateToShowNotHour}
												className="left20"
											/>
										</div>
										<div className="columns-row-between ">
											<Field
												name="ticketHeader.feeAmount02"
												component={TextField}
												floatingLabelText="Total Pagar"
												disabled
												format={Util.formatPesos}
											/>
											<Field
												name="ticketHeader.expiredDate02"
												component={TextField}
												floatingLabelText="2do Vencimiento"
												disabled
												format={Util.formatDateToShowNotHour}
												className="left20"
											/>
										</div>
									</div>
									<div className="columns-column-between columns-half bottom25 left20">
										{this.props.modeCRU !== MODE_CRU_SHOW &&
										this.props.modeCRU !== MODE_CRU_CREATE ? (
											<AddPayment
												nameFieldArray="ticketHeader.listPartialPayment"
												nameFieldPaymentDate="paidDate"
												nameFieldPayment="paidAmount"
												nameFieldCompletesPayment="totalPayment"
												paymentMethodsList={this.props.paymentMethodsList}
												nameFieldPaymentMethod={"paymentEntity.id"}
											/>
										) : null}
									</div>
								</VerticalListFields>
							</div>
						</form>
						<div className="justify-content-end columns-column-simple">
							<Link to={BOLETAS}>
								<FlatButton label="Volver" style={{ margin: 5 }} />
							</Link>
							{this.props.modeCRU !== MODE_CRU_SHOW ? (
								<div>
									<RaisedButton
										label="Generar nueva boleta"
										primary
										style={{ margin: 5 }}
										onClick={this.props.handleSubmit(this.onSubmit.bind(this))}
										disabled={
											this.props.modeCRU === MODE_CRU_CREATE
												? !this.props.company || this.state.isTicketGenerated
												: this.state.isTicketGenerated
										}
									/>
									<RaisedButton
										label="Registrar Pagos"
										primary
										style={{ margin: 5 }}
										onClick={this.props.handleSubmit(
											this.onSubmitPartialPayment.bind(this)
										)}
										disabled={
											this.props.modeCRU === MODE_CRU_CREATE ? true : false
										}
									/>
								</div>
							) : null}
						</div>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	const selector = formValueSelector("TicketOnDemandForm");
	return {
		modeCRU: store.boleta.modeCRU,
		company: store.empresa.empresa,
		formValues: selector(store, "cuitCompany", "yearPeriod", "monthPeriod"),
		boleta: store.boleta.boleta,
		paymentMethodsList: store.paymentMethod.paymentMethodsList
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDownloadFile,
			actionGenerateTicketOnDemand,
			actionGetEmpresaByCuit,
			actionRegenerateTicketOnDemand,
			actionUpdateBoleta,
			actionGetPaymentMethodList
		},
		dispatch
	);
}

export default reduxForm({
	form: "TicketOnDemandForm"
})(connect(mapStateToProps, mapDispatchToProps)(TicketOnDemandForm));



// WEBPACK FOOTER //
// ./src/screens/Boleta/TicketOnDemandForm.js